import React from 'react';
import clsx from 'clsx';

import { Icon } from '@/ui-kit/icon/icon';

import './FieldError.scss';

export type FieldErrorMessageProps = {
  message?: string;
  className?: string;
};

/** Shared field-error row (icon + message) without Formik. */
export const FieldErrorMessage: React.FC<FieldErrorMessageProps> = ({
  message,
  className,
}) => {
  if (!message) return null;

  return (
    <div className={clsx('field-error', className)} role="alert">
      <Icon type="x" color="var(--color_error-dark)" />
      <span className="field-error__message">{message}</span>
    </div>
  );
};
